
import { FOOTER_COLUMNS } from '@marketplace/components/footer/data/footer-columns.js'
import { PAYMENT_METHODS } from '@marketplace/components/footer/data/payment-methods.js'
import OcFooterContainer from '@marketplace/components/footer/parts/oc-footer-container.vue'
import GermanLogos from '@marketplace/components/logos/GermanLogos.vue'
import CurrentLanguageMenuItem from '@marketplace/components/nav/parts/current-language-menu-item.vue'
import ocDrawerMixin from '@marketplace/components/shared/drawer/ocDrawerMixin.js'
import BaseToggle from '@marketplace/components/shared/toggle/BaseToggle.vue'
import { DEFAULT_LOCALE } from '@marketplace/config/i18n.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
    name: 'OcFooter',

    components: {
        CurrentLanguageMenuItem,
        OcFooterContainer,
        BaseToggle,
        GermanLogos,
    },

    mixins: [ocDrawerMixin],

    data() {
        return {
            userType: window.Store.accountType,
            footerColumns: FOOTER_COLUMNS,
            currentYear: new Date().getFullYear(),
        }
    },

    computed: {
        ...mapGetters('ocplus', ['canSeeOcPlus']),
        ...mapGetters('global', ['account', 'getPaymentMethods']),

        shouldSeeTrustBadge() {
            return this.isGerman
        },
        shouldSeeImpressum() {
            return this.isGerman
        },
        isGerman() {
            return window.Store?.country === 'de' || this.$locale === 'de'
        },
        columnComponent() {
            return this.$breakpoint.includes('mobile') ? BaseToggle : 'div'
        },
        paymentMethods() {
            const countryCode = window.Store.country ?? this.$locale

            if (!this.$helpers.isLoggedIn) {
                return (
                    PAYMENT_METHODS[countryCode] ?? PAYMENT_METHODS.default
                ).map((method) => {
                    return {
                        name: method.name,
                        logo: require(`~assets/images/payment-logos/${method.logo}`),
                    }
                })
            }

            return this.getPaymentMethods
                ?.filter((method) => method.logos)
                ?.filter((method) => {
                    if (method.id !== 'mollie-applepay') {
                        return true
                    }
                    return (
                        window.ApplePaySession &&
                        window.ApplePaySession.canMakePayments()
                    )
                })
                ?.reduce((acc, method) => {
                    const logosWithMethodData = method.logos.map((logo) => ({
                        id: method.id,
                        name: method.name,
                        logo,
                    }))

                    return acc.concat(logosWithMethodData)
                }, [])
        },
        socials() {
            return [
                {
                    icon: 'fab fa-instagram',
                    label: this.$t('nav.instagram'),
                    href: this.isGerman
                        ? 'https://www.instagram.com/orderchamp_de/'
                        : 'https://www.instagram.com/orderchamp/',
                },
                {
                    icon: 'fab fa-facebook',
                    label: this.$t('nav.facebook'),
                    href: 'https://www.facebook.com/orderchamp/',
                },
                {
                    icon: 'fab fa-linkedin',
                    label: this.$t('nav.linkedin'),
                    href: 'https://www.linkedin.com/company/orderchamp',
                },
                {
                    icon: 'fab fa-pinterest',
                    label: this.$t('nav.pinterest'),
                    href: 'https://www.pinterest.com/orderchamp',
                },
            ]
        },
        columnsToIncludeInLoop() {
            /* This was added so that the fourth column keeps the same logic as the rest of the footer
				and not have 2 links hardcoded.
				This removes the 4th element of the the footerColumns so that the rest of the code works as before.
			*/
            return Object.values(this.footerColumns).slice(0, 3)
        },
    },

    methods: {
        localizeHref({ direct, isHubSpot, locales, path }) {
            if (!direct) {
                return this.localeUrl(path)
            }

            const userLocale = locales?.[this.$locale] ?? DEFAULT_LOCALE

            if (locales !== undefined || isHubSpot) {
                return this.localeUrl(
                    path,
                    locales !== undefined ? userLocale : null,
                    isHubSpot
                )
            }

            return path
        },
        canBeShown(permission) {
            if (!permission) return true
            if (permission.includes('isOCPlus')) return this.canSeeOcPlus
            if (permission.includes(this.userType)) return true
            if (permission.includes('isGuest')) return !this.$helpers.isLoggedIn

            return false
        },
        triggerLanguageCurrencyModal() {
            EventBus.$emit('modal-open', 'modal-language-picker')
        },
    },
}
